import { P2GAdaptiveOverlay, P2GBox } from '@parcel2go/core-ui';
import { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const CmsContent = lazy(() => import('~/components/core/content/cms-content'));

type props = { open: boolean; onClose: () => void; contentKey: string };

export const ServiceTerms = ({ open, onClose, contentKey }: props) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  return (
    <P2GAdaptiveOverlay
      isOpen={open}
      onClose={onClose}
      modalTitle=""
      closeButtonText={t('CLOSE_DRAWER', { defaultValue: 'Close' })}
    >
      <Suspense>
        <P2GBox p={2}>
          <CmsContent contentKey={contentKey} />
        </P2GBox>
      </Suspense>
    </P2GAdaptiveOverlay>
  );
};
